import Vue from 'vue'
export const EventBus = new Vue()
export const ON_SHOW_MAP = 'on_show_map'
export const ON_SEARCH_PAGE_EDIT = 'on_search_page_edit'
export const ON_SEARCH_PAGE_CREATE = 'on_search_page_create'
export const ON_SEARCH_PAGE_DELETE = 'on_search_page_delete'
export const TRIGGER_SEARCH = 'trigger_search'